import {
	FETCH_EMAILS_BEGIN,
	FETCH_EMAILS_ERROR,
	FETCH_EMAILS_SUCCESS,
	FETCH_EMAIL_DOCUMENTS_SUCCESS,
	FETCH_EMAIL_TEMPLATES_SUCCESS,
	POST_EMAIL_BEGIN,
	POST_EMAIL_ERROR,
	POST_EMAIL_RESET,
	POST_EMAIL_SUCCESS,
} from "../actions/emailActions"

// Slice e-mails (GE-25) : sorti de `atelierInfo`, la file étant désormais
// générique atelier/dépannage.
const initialState = {
	// Historique des envois de la fiche courante.
	emails: [],
	fetchEmails: { loading: false, error: false },
	postEmail: { saving: false, saved: false, error: false },
	// Documents joignables de la fiche courante (proposés ⇔ fichier existant).
	documents: [],
	// Modèles disponibles (aussi consommés par l'onglet de configuration).
	templates: [],
}

export default function emailReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_EMAILS_BEGIN:
			return { ...state, fetchEmails: { loading: true, error: false } }
		case FETCH_EMAILS_SUCCESS:
			return {
				...state,
				emails: action.payload,
				fetchEmails: { loading: false, error: false },
			}
		case FETCH_EMAILS_ERROR:
			return {
				...state,
				fetchEmails: { loading: false, error: action.payload },
			}
		case POST_EMAIL_BEGIN:
			return {
				...state,
				postEmail: { saving: true, saved: false, error: false },
			}
		case POST_EMAIL_SUCCESS:
			// Le serveur renvoie l'envoi créé + l'historique à jour.
			return {
				...state,
				emails: action.payload.envois,
				postEmail: { saving: false, saved: true, error: false },
			}
		case POST_EMAIL_RESET:
			return {
				...state,
				postEmail: { saving: false, saved: false, error: false },
			}
		case POST_EMAIL_ERROR:
			return {
				...state,
				postEmail: { saving: false, saved: false, error: action.payload },
			}
		case FETCH_EMAIL_DOCUMENTS_SUCCESS:
			return { ...state, documents: action.payload }
		case FETCH_EMAIL_TEMPLATES_SUCCESS:
			return { ...state, templates: action.payload }
		default:
			return state
	}
}
